import React from "react";
import {PageHero} from "../common/PageHero";

const documents = [
    {label: 'Aansluitingsformulier', hint: 'PDF', href: 'aansluitingsformulier.pdf', download: 'aansluitingsformulier.pdf'},
    {label: 'Huishoudelijk reglement', hint: 'DOCX', href: 'huishoudelijkreglement.docx', download: 'huishoudelijkreglement.docx'},
    {label: 'Speelschema jeugd', hint: 'Google Sheets', href: 'https://docs.google.com/spreadsheets/d/1QB4JZIie9NNIV_txyvCPpNK2e-TLUS6DpOa5J5A-SO8/edit?gid=0#gid=0'}
];

export const Document = () => {
    return (
        <>
            <PageHero title={'Documenten'}
                      badge={'Downloads'}
                      lead={'Formulieren en reglementen van de club.'}/>
            <div className={'ttc-section'}>
                <div className={'ttc-list'}>
                    {documents.map((doc) => (
                        <a className={'ttc-list-row'} key={doc.label} href={doc.href} download={doc.download}>
                            <span className={'ttc-list-label'}>{doc.label}</span>
                            <span className={'ttc-tag'}>{doc.hint}</span>
                        </a>
                    ))}
                </div>
            </div>
        </>
    )
}
